import {Repository, createRepository} from '@/repositories/Base/Repository'

class VnsRepository extends Repository {
    endpoint = 'vam/vns'

    fetchToMonitor(params) {
        return this.$axios.get(`${this.endpoint}/monitor`, {params})
    }

    fetchAllActive(params) {
        return this.$axios.get(`vns/filter`, {params})
    }

    fetchTable(params) {
        return this.$axios.get(`vns/table`, {params})
    }

    search(params) {
        return this.$axios.get(`vns/list`, {params})
    }

    show(id) {
        return this.$axios.get(`vns/${id}/table`, {})
    }

    post(params) {
        return this.$axios.post(`vns/store`, params)
    }

    put(id, params) {
        return this.$axios.post(`vns/store`, {...params, id: id})
    }
}

export default new VnsRepository()

export const create = createRepository(VnsRepository)
